<template>
    <ContainerLayout :page="type == 'customer' ? 2 : 0" :loading="loading">
        <template v-slot:navbar>
            <nav v-if="type == 'customer'" class="navbar navbar-expand navbar-light bg-white text-dark">
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
                <div class="navbar-nav ml-auto">
                    <NavbarNotification :loading="loading" />
                </div>
            </nav>
            <nav v-else class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link to="/profile/company" class="nav-link">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
            <div class="w-100 d-flex flex-row justify-content-start align-items-center py-2 px-4 bg-white"
                style="overflow-x: auto; overflow-y: hidden; white-space: nowrap;">
                <div class="mr-2" :style="isEmpty ? 'display: none;' : ''">
                    <div id="dropdown-status" class="py-2 px-3 clear-button badge-custom badge-outlined badge-secondary"
                        @click.prevent="clearFilter">
                        <font-awesome-icon icon="x" />
                    </div>
                </div>
                <div class="mr-2" style="width: auto;">
                    <VDropdown :distance="6" :skidding="0" v-model:shown="isDropdownStatusOpen">
                        <div id="dropdown-status" class="py-2 px-3 dropdown-button badge-custom badge-outlined badge-main">
                            <span id="dropdown-status-text">
                                {{
                                    selectedStatus.length > 0 ? selectedStatus.map(s => s.label).join(', ') : 'Select Status'
                                }}
                            </span>
                            <font-awesome-icon icon="chevron-down" class="pl-3 ml-auto"
                                :class="isDropdownStatusOpen ? ' d-none' : ''" />
                            <font-awesome-icon icon="chevron-up" class="pl-3 ml-auto"
                                :class="isDropdownStatusOpen ? '' : ' d-none'" />
                        </div>

                        <template #popper>
                            <div class="dropdown-items-container">
                                <div v-for="(item, index) in statusOptions" :key="index"
                                    class="dropdown-item py-2 px-3 d-flex justify-content-start align-items-center"
                                    :class="{ 'selected-item': isSelected(item) }" @click="changeStatus(item)">
                                    <div>
                                        {{ item.label }}
                                    </div>
                                    <font-awesome-icon v-if="isSelected(item) && item.value != 'ALL'" icon="times"
                                        class="ml-auto" @click.stop="removeStatus(item)" />
                                </div>
                            </div>
                            <div class="dropdown-done-button">
                                <button class="btn btn-main w-100" @click="applySelection">{{ $t('Submit') }}</button>
                            </div>
                        </template>
                    </VDropdown>
                </div>
                <div id="div-filter-date" class="d-flex" style="width: auto; min-width: 165px; max-width: 165px;">
                    <VueDatePicker class="w-100" v-model="filterDates" :locale="currentUser ? currentUser.locale : 'id'"
                        range auto-apply :enable-time-picker="false" :teleport="true" :format="formatFilterDates"
                        @cleared="clearFilterDates" :placeholder="$t('All Date')" />
                </div>
            </div>
        </template>
        <div v-if="loaded_data" class="content px-1">
            <div v-if="transactions.length == 0"
                class="d-flex flex-column justify-content-center align-items-center text-center">
                <img id="img-card" class="img-card" src="@/assets/images/logo-empty.png" />
                <div v-if="isEmpty" class="d-flex flex-column">
                    <label class="mt-4 mb-1 font-weight-bold">{{ $t('Your transaction history is empty!') }}</label>
                    <label class="text-muted">{{ $t('Please make a transaction to see your history') }}</label>
                </div>
                <div v-else class="d-flex flex-column">
                    <label class="mt-4 mb-1 font-weight-bold">{{ $t('No results found!') }}</label>
                    <label class="text-muted">{{ $t('Please try again with different filters') }}</label>
                </div>
            </div>
            <div v-else class="w-100 row pt-0 mx-0">
                <div v-for="(item, index) in transactions" :key="index"
                    class="col-lg-4 col-md-6 col-sm-12 col-12 mb-4 px-0 px-md-2">
                    <div class="h-100 card-container" @click.prevent="detail(item)">
                        <div class="w-100 card"
                            style="border-radius: 0.25rem; border: 1.5px solid rgba(0,0,0,.125); box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); cursor: pointer; display: flex; flex-direction: column; justify-content: space-between;">
                            <div class="card-header p-1">
                                <div class="d-flex align-items-start px-2 py-1">
                                    <div class="d-flex flex-column justify-content-start align-items-start">
                                        <small style="font-size: 12px;">
                                            {{ formatDateTime(item.created_at) }}
                                        </small>
                                        <small class="text-muted" style="font-size: 11px;">
                                            {{ item.invoice_number }}
                                        </small>
                                    </div>
                                    <div class="ml-auto mt-1 d-flex align-items-center">
                                        <div v-if="item.status == 'PAYMENT'" class="badge badge-warning text-white"
                                            style="font-weight: 600; font-size: 11px;">
                                            {{ $t('Waiting for Payment') }}
                                        </div>
                                        <div v-if="item.status == 'PAID'" class="badge badge-main"
                                            style="font-weight: 600; font-size: 11px;">
                                            {{ $t('On Processing') }}
                                        </div>
                                        <div v-if="item.status == 'COMPLETED'" class="badge badge-success"
                                            style="font-weight: 600; font-size: 11px;">
                                            {{ $t('Completed') }}
                                        </div>
                                        <div v-if="item.status == 'FAILED'" class="badge badge-danger"
                                            style="font-weight: 600; font-size: 11px;">
                                            {{ $t('Failed') }}
                                        </div>
                                        <div v-if="item.status == 'EXPIRED'" class="badge badge-danger"
                                            style="font-weight: 600; font-size: 11px;">
                                            {{ $t('Expired') }}
                                        </div>
                                        <div v-if="item.status == 'CANCELLED BY USER'" class="badge badge-danger"
                                            style="font-weight: 600; font-size: 11px;">
                                            {{ $t('Cancelled by user') }}
                                        </div>
                                        <div v-if="item.status == 'CANCELLED BY SYSTEM'" class="badge badge-danger"
                                            style="font-weight: 600; font-size: 11px;">
                                            {{ $t('Cancelled by system') }}
                                        </div>
                                        <div v-if="item.status == 'CANCELLED BY PROVIDER'" class="badge badge-danger"
                                            style="font-weight: 600; font-size: 11px;">
                                            {{ $t('Cancelled by provider') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="m-3">
                                <div class="row">
                                    <div class="col-2">
                                        <div class="h-100 d-flex justify-content-start align-items-center">
                                            <img :src="item.transaction_products[0].product_image_url"
                                                style="width: auto; height: 30px;">
                                        </div>
                                    </div>
                                    <div class="col-10">
                                        <div class="d-flex flex-column justify-content-start align-items-start">
                                            <small style="font-weight: 700;">
                                                {{ item.transaction_products[0].current_product_name }}
                                            </small>
                                            <small class="text-muted" style="font-size: 13px;">
                                                {{ item.transaction_products[0].current_product_category_name }}
                                            </small>
                                            <div class="mt-1">
                                                <span v-if="item.transaction_products[0].product_detail_detail_label"
                                                    class="badge badge-main mr-1">
                                                    {{ item.transaction_products[0].product_detail_detail_label }}
                                                </span>
                                                <span v-if="(totalProduct(item) - 1) > 0"
                                                    class="badge badge-outline badge-main mr-1">
                                                    + {{ (totalProduct(item) - 1) }}
                                                    {{ (totalProduct(item) - 1) > 1 ? $t('Products') : $t('Product') }}
                                                </span>
                                                <span v-if="totalAddon(item) > 0" class="badge badge-outline badge-main">
                                                    + {{ totalAddon(item) }}
                                                    {{ totalAddon(item) > 1 ? $t('Bundles') : $t('Bundle') }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.location_id || item.branch_name || item.branch_brand" class="card-footer p-1"
                                style="background-color: white;">
                                <div class="d-flex align-items-center px-2 py-1">
                                    <div class="d-flex flex-column">
                                        <small v-if="item.location_id" style="font-size: 12px;">
                                            {{ item.current_location_name + ' - ' +
                                                (item.location_airport_code ?
                                                    item.location_airport_code + ', ' : '') +
                                                item.location_city + ', ' +
                                                item.location_province }}
                                        </small>
                                        <small v-if="item.branch_name || item.branch_brand"
                                            style="font-size: 12px; font-weight: 500;">
                                            {{ item.branch_name }} <span style="font-size: 11px; font-weight: 400;">{{
                                                item.branch_brand ? ' - ' + item.branch_brand : ''
                                            }}</span>
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer p-1">
                                <div v-if="type == 'customer'" class="d-flex align-items-center px-2 py-1">
                                    <div class="d-flex flex-column justify-content-start align-items-start">
                                        <small style="font-size: 11px;">
                                            {{ $t('Total') }}
                                        </small>
                                        <small class="text-main" style="font-weight: 700; font-size: 13px;">
                                            {{ item.amount != null ? item.amount_formatted : item.original_amount_formatted
                                            }}
                                        </small>
                                    </div>
                                    <div class="ml-auto d-flex align-items-center">
                                        <button v-if="item.status == 'PAYMENT'" class="btn btn-main btn-sm"
                                            @click.stop="goToPaymentIndex(item)">
                                            {{ $t('Payment') }}
                                        </button>
                                        <button v-if="item.status == 'PAID' || item.status == 'COMPLETED'"
                                            class="btn btn-outline-main btn-sm" @click.stop="readdItems(item)">
                                            {{ $t('Repurchase') }}
                                        </button>
                                        <!-- <button class="btn btn-outline-secondary btn-sm" ml-1 @click.stop="showMore(item)">
                                            <font-awesome-icon icon="ellipsis" />
                                        </button> -->
                                    </div>
                                </div>
                                <div v-else class="d-flex align-items-center px-2 py-1">
                                    <div class="d-flex flex-column justify-content-start align-items-start">
                                        <small style="font-size: 11px;">
                                            {{ item.user.name }}
                                        </small>
                                        <small class="text-muted" style="font-weight: 500; font-size: 11px;">
                                            {{ item.user.email }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="content px-1">
            <div class="w-100 row pt-0 mx-0">
                <div v-for="(item, index) in [1, 2, 3]" :key="index"
                    class="col-lg-4 col-md-6 col-sm-12 col-12 mb-4 px-0 px-md-2">
                    <div class="skeleton-card" />
                </div>
            </div>
        </div>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../ContainerLayout.vue";
import NavbarNotification from "../NavbarNotification.vue";
import TransactionService from "@/services/transaction.service";
import moment from 'moment';
import { ref } from 'vue';

export default {
    name: "TransactionIndex",
    components: {
        ContainerLayout,
        NavbarNotification,
    },
    props: {
        type: {
            type: String,
            required: true,
            default: 'customer',
        },
    },
    data() {
        return {
            loaded_data: false,
            loading: false,
            isDropdownStatusOpen: false,
            selectedStatus: this.type == 'customer' ? [{ value: 'PAYMENT', label: this.$t('Payment') }, { value: 'PAID', label: this.$t('On Processing') }, { value: 'COMPLETED', label: this.$t('Completed') }] : [{ value: 'PAID', label: this.$t('On Processing') }, { value: 'COMPLETED', label: this.$t('Completed') }],
            statusOptions: [
                { value: 'ALL', label: this.$t('All Status') },
                { value: 'PAYMENT', label: this.$t('Payment') },
                { value: 'PAID', label: this.$t('On Processing') },
                { value: 'COMPLETED', label: this.$t('Completed') },
                { value: 'FAILED', label: this.$t('Failed') },
                { value: 'EXPIRED', label: this.$t('Expired') },
                { value: 'CANCELLED', label: this.$t('Cancelled') },
            ],
            filterDates: null,
            transactions: [],
        };
    },
    setup() {
        const buttonRef = ref(null);
        const show = ref(false);

        const items = ['Item 1', 'Item 2', 'Item 3'];

        const floatingOptions = {
            placement: 'bottom-start', // this is just an example, you can customize it as per your needs
        };

        const toggleDropdown = () => {
            show.value = !show.value;
        };

        return {
            buttonRef,
            show,
            items,
            floatingOptions,
            toggleDropdown,
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
        currentCompany() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user.company : null;
        },
        isEmpty() {
            return this.selectedStatus.length === 0 || (this.selectedStatus.length === 1 && this.selectedStatus[0].value === 'ALL') && this.filterDates == null;
        },
    },
    created() {
        this.loadData();
    },
    methods: {
        clearFilter() {
            this.selectedStatus = [{ value: 'ALL', label: this.$t('All Status') }];
            this.prevSelectedStatus = []; // Set the previous selected status to 'ALL'
            this.isDropdownStatusOpen = false;
            this.isSubmitClicked = false;
            this.filterDates = null;
            this.loadData();
        },

        changeStatus(status) {
            if (!this.prevSelectedStatus || this.prevSelectedStatus.length == 0) {
                this.prevSelectedStatus = [...this.selectedStatus]; // Set the previous selected status to the current selected status
            }

            // Check if 'ALL' is selected
            if (status.value === 'ALL') {
                // If 'ALL' is selected, set selectedStatus to only contain 'ALL'
                this.selectedStatus = [status];
                // this.isDropdownStatusOpen = false; // Close the dropdown
            } else {
                // Check if 'ALL' is currently in the array and remove it
                this.selectedStatus = this.selectedStatus.filter(s => s.value !== 'ALL');

                // Find the index of the selected status
                const index = this.selectedStatus.findIndex(s => s.value === status.value);

                // Add or remove the status from the selectedStatus array
                if (index === -1) {
                    this.selectedStatus.push(status);
                } else {
                    this.selectedStatus.splice(index, 1);
                }

                // Close the dropdown only if all other statuses are selected
                // if (this.selectedStatus.length === this.statusOptions.length - 1) {
                //     this.isDropdownStatusOpen = false;
                // }
            }

            // this.loadData();
        },
        removeStatus(status) {
            if (!this.prevSelectedStatus || this.prevSelectedStatus.length === 0) {
                this.prevSelectedStatus = [...this.selectedStatus]; // Store current selected status
            }

            this.selectedStatus = this.selectedStatus.filter(s => s.value !== status.value);

            // Check if the selectedStatus array is empty after removal
            if (this.selectedStatus.length === 0) {
                // Find the 'ALL' status object from the statusOptions
                const allStatus = this.statusOptions.find(s => s.value === 'ALL');

                // Set the selectedStatus to 'ALL'
                if (allStatus) {
                    this.selectedStatus = [allStatus];
                    // this.isDropdownStatusOpen = false;
                }
            }

            // this.loadData();
        },

        applySelection() {
            this.isSubmitClicked = true;
            this.isDropdownStatusOpen = false;
            this.prevSelectedStatus = []; // Set the previous selected status to 'ALL'
            this.loadData();
            this.$nextTick(() => {
                this.isSubmitClicked = false;
            });
        },

        isSelected(status) {
            return this.selectedStatus.some(s => s.value === status.value);
        },

        clearFilterDates() {
            this.filterDates = null;
            this.loadData();
        },

        formatFilterDates(dates) {
            return moment(dates[0]).locale(this.currentUser ? this.currentUser.locale : 'id').format('DD MMM YYYY') + ' - ' + moment(dates[1]).locale(this.currentUser ? this.currentUser.locale : 'id').format('DD MMM YYYY');
        },

        loadData() {
            this.loaded_data = false;
            this.loading = true;
            let loader = this.$loading.show();

            let user_ids = [];
            let company_id = null;
            if (this.type == 'customer') {
                user_ids = this.currentUser ? [this.currentUser.id] : [];
            } else {
                company_id = this.currentCompany ? this.currentCompany.id : null;
            }

            let statuses = this.selectedStatus.map(s => s.value);
            let startDate = null;
            let endDate = null;
            if (this.filterDates) {
                startDate = moment(this.filterDates[0]).format('MM/DD/YYYY');
                endDate = moment(this.filterDates[1]).format('MM/DD/YYYY');
            }

            let data = {};
            if (this.type == 'customer') {
                data = {
                    user_ids: user_ids,
                };
            } else {
                data = {
                    company_id: company_id,
                };
            }
            data = {
                ...data,
                statuses: statuses,
                start_date: startDate,
                end_date: endDate,
            };

            TransactionService.getByUserIds(data)
                .then((response) => {
                    this.loaded_data = true;
                    this.loading = false;
                    loader.hide();

                    if (response.data.status == "success") {
                        this.transactions = response.data.data;
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'error');
                    }
                })
                .catch((error) => {
                    this.loaded_data = true;
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error');
                });
        },

        formatDateTime(date) {
            return moment(date).locale(this.currentUser ? this.currentUser.locale : 'id').format('DD MMM YYYY');
        },

        totalProduct(data) {
            return data.transaction_products.length;
        },

        totalAddon(data) {
            let total = 0;
            data.transaction_products.forEach((product) => {
                total += product.transaction_product_addons.length;
            });
            return total;
        },

        goToPaymentIndex(transaction) {
            this.$router.push({
                name: "Payment",
                query: {
                    data: this.$encryptString(transaction.id, 'encryptKey')
                }
            });
        },

        readdItems(transaction) {
            this.loading = true;
            let loader = this.$loading.show();

            TransactionService.readdItems(transaction.id)
                .then((response) => {
                    this.loading = false;
                    loader.hide();

                    if (response.data.status == "success") {
                        this.$vueAlert.alert(response.data.message, null, 'success').then(() => {
                            if (transaction.transaction_products.length > 0) {
                                if (transaction.transaction_products.length == 1) {
                                    let cart_ids = [];
                                    for (const transaction_product of transaction.transaction_products) {
                                        cart_ids.push(transaction_product.cart_id);
                                    }

                                    let encrypted = this.$encryptString(JSON.stringify(cart_ids), 'encryptKey');
                                    this.$router.push({
                                        name: "Purchase Detail",
                                        query: {
                                            data: encrypted,
                                            from: 'cart',
                                        },
                                    });
                                } else {
                                    this.$router.push({
                                        name: "Cart",
                                    });
                                }
                            }
                        });
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'error');
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error');
                });
        },

        showMore(transaction) {
            console.log(transaction);
        },

        detail(transaction) {
            this.$router.push({
                name: "Transaction Details",
                query: {
                    id: transaction.id
                }
            });
        }
    },
    watch: {
        filterDates: function (val) {
            if (val) {
                document.getElementById('div-filter-date').style.minWidth = '242px';
                document.getElementById('div-filter-date').style.maxWidth = '242px';
                this.loadData();
            } else {
                document.getElementById('div-filter-date').style.minWidth = '165px';
                document.getElementById('div-filter-date').style.maxWidth = '165px';
            }
        },

        isDropdownStatusOpen(newValue) {
            // Check if the dropdown is being closed and prevSelectedStatus is not empty
            if (!this.isSubmitClicked && !newValue && this.prevSelectedStatus && this.prevSelectedStatus.length > 0) {
                this.selectedStatus = [...this.prevSelectedStatus];
                this.prevSelectedStatus = []; // Set the previous selected status to 'ALL'
            }
        }
    },
};
</script>

<style scoped>
.skeleton-card {
    width: 100%;
    height: 259.67px;
    background-color: #e6e6e6;
    border-radius: 5px;
}
</style>

<style>
.clear-button {
    font-weight: 600 !important;
    font-size: 14px !important;
    border-width: 2px !important;
    border-radius: 16px !important;
    cursor: pointer !important;
}

.clear-button:hover {
    background-color: #f5f5f5 !important;
}

.dropdown-button {
    min-width: 150px !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    border-width: 2px !important;
    border-radius: 16px !important;
    cursor: pointer !important;
}

.dropdown-button:hover {
    background-color: #f5f5f5 !important;
}

.dropdown-items-container {
    min-width: 160px !important;
    display: flex !important;
    flex-direction: column !important;
    /* border: 1px solid #999; */
    border-radius: 0.25rem;
}

.dropdown-item {
    padding: 0.5rem 1rem !important;
    font-size: 14px !important;
    color: #212529 !important;
    cursor: pointer !important;
    border-radius: 0.25rem;
}

.dropdown-item:hover {
    background-color: #f5f5f5 !important;
    color: #275D93 !important;
    font-weight: 500 !important;
}

.dropdown-item:focus {
    background-color: #f5f5f5 !important;
    color: #275D93 !important;
    font-weight: 500 !important;
}

.dropdown-item.selected-item {
    background-color: #f5f5f5 !important;
    color: #275D93 !important;
    font-weight: 700 !important;
}

.dropdown-done-button {
    padding-top: 10px;
    text-align: center;
}

.dropdown-done-button button {
    border-radius: 0 0 0.25rem 0.25rem !important;
}

/* .v-popper__arrow-outer {
    visibility: hidden !important;
}

.v-popper__arrow-inner {
    visibility: hidden !important;
} */

.dp__theme_light {
    --dp-font-size: 14px;
    --dp-border-radius: 16px;
    --dp-primary-color: #275D93 !important;
}

.dp__input {
    border-width: 2px !important;
    border-radius: 16px !important;
    border-color: #275D93 !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    color: #275D93 !important;
}

.dp__input:hover {
    background-color: #f5f5f5 !important;
}

.dp__icon {
    color: #275D93 !important;
}

.dp__input::placeholder {
    color: #275D93 !important;
    opacity: 1 !important;
}
</style>